import type { IconName } from 'common/components/Icon';

interface IconConfig {
  name: IconName;
  size: number;
  gap?: string;
}

interface FilterIconMapper {
  [key: string]: IconConfig;
}

const FILTER_ICON_MAP: FilterIconMapper = {
  immediateDelivery: {
    name: 'truck',
    size: 26,
    gap: 'sp_2',
  },
  discounted: {
    name: 'discount',
    size: 14,
    gap: 'sp_6',
  },
};

export const getFilterIcon = (filterKey?: string): IconConfig | null => {
  if (!filterKey) {
    return null;
  }

  return FILTER_ICON_MAP[filterKey] || null;
};
